import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams, Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/";
const getToday = () => {
  const date = new Date();

  const years = date.getFullYear();

  const months = String(date.getMonth() + 1).padStart(2, "0");

  const days = String(date.getDate()).padStart(2, "0");

  return `${years}-${months}-${days}`;
};
const HodPerformanceReview = () => {
  const saveTimers = useRef({});
  const MANAGER_ID = JSON.parse(localStorage.getItem("userId"));
  const { employeeId, deptId, systemRole } = useParams();
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("key"));
  const [data, setData] = useState(null);
  const [actualValue, setActualValue] = useState([]);
  const [reviewStatus, setReviewStatus] = useState("");
  const [statusKpi, setKpiStatus] = useState("");
  const [rating, setRating] = useState("");
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [kraList, setKraList] = useState([]);
  const [modalReview, setModalReview] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [status, setStatus] = useState("Pending");
  const [attendance, setAttendance] = useState([]);
  const [allocation, setAllocation] = useState([]);
  const [allocations, setAllocations] = useState([]);
  const [kpis, setKpis] = useState([]);

  const currentdate = new Date();

  const currentYear = currentdate.getFullYear();
  const currentMonth = currentdate.getMonth() + 1;
  const currentday = currentdate.getDate();
  const [filters, setFilters] = useState({
    date: getToday(),
    day: currentday,
    year: currentYear,
    month: currentMonth,
    frequency: "Monthly",
    quarter: ["Q1", "Q2", "Q3", "Q4"],
    status: "",
  });
  // useEffect(() => {
  //   loadKra();
  // }, []);
  const restReview = async () => {
    setReviewStatus("");
    setRating("");
    setKpiStatus("");
    setComment("");
    setModalReview(false);
    setCurrentPage(1);
  };
  const handleDateChange = (date) => {
    if (!date) {
      setFilters((prev) => ({
        ...prev,
        date: "",
      }));
      return;
    }
    // Store date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    setFilters((prev) => ({
      ...prev,
      date: formattedDate,
    }));
  };
  const clearFilters = () => {
    setFilters({
      date: getToday(),
      day: currentday,
      year: currentYear,
      month: currentMonth,
      frequency: "Monthly",
      quarter: "",
      status: "",
    });

    setCurrentPage(1);
  };
  const openReviewModelHandler = () => {
    setModalReview(true);
  };
  const handleClose = () => {
    setModalReview(false);
    setCurrentPage(1);
  };
  // const loadKra = async () => {
  //   try {
  //     const res = await axios.get(`${API}api/Performance/kra`, {
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token.value}`,
  //       },
  //     });

  //     if (res.data.success) {
  //       setKraList(res.data.data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const loadReview = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API}api/Performance/hod/review/${employeeId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
          params: {
            manager_id: MANAGER_ID,
            deptId: deptId,
            systemRole: systemRole,
            month: filters.month,
            year: filters.year,
            day: filters.day,
            frequency: filters.frequency,
            quarter: filters.quarter,
            date: filters.date,
            page: currentPage,
            pageSize: recordsPerPage,
          },
        },
      );

      const result = response.data.data;
      console.log("Performance Review:", result);
      setData(result);
      setTotalRecords(Number(result.totalAllocation || 0));
      setStatus(result.review?.status || "Pending");
      setAttendance(result.attendance);
      setAllocation(result.allocation);
      setAllocations(result.allocations);
      setKpis(result.kpis);
      if (result?.review) {
        setRating(result.review.manager_rating || "");
        setComment(result.review.manager_comment || "");
      }
    } catch (error) {
      console.error("Load review error:", error);

      alert(
        error.response?.data?.message || "Unable to load performance review",
      );
    } finally {
      setLoading(false);
    }
  };
  const submitReview = async (action) => {
    if (action === "Approved" && !rating) {
      alert("Please select manager rating");
      return;
    }
    if (reviewStatus != 1 && !reviewStatus) {
      alert("Please select review status");
      return;
    }
    const confirmed = window.confirm(
      `Are you sure you want to ${action.toLowerCase()} this performance?`,
    );
    if (!confirmed) {
      return;
    }
    try {
      setSaving(true);
      const endpoint = `${API}api/Performance/savePerformance`;
      console.log("Performance Review data:", data);
      const payload = {
        employee_id: employeeId,
        month: filters.month,
        year: filters.year,
        review_date: filters.date,
        allocation_score: Number(data?.allocation.allocation_score || 0),
        hours_score: Number(data?.allocation.hours_score || 0),
        daily_score: Number(data?.daily_score || 0),
        kpi_score: Number(data?.kpi_score || 0),
        final_score: Number(data?.final_score || 0),
        manager_id: MANAGER_ID,
        kra_id: statusKpi || null,
        rating: rating ? Number(rating) : null,
        comment: comment?.trim() || null,
        status: reviewStatus,
      };

      console.log("Save Performance Payload:", payload);
      const response = await axios.post(endpoint, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });
      console.log("Save Performance Response:", response.data);
      alert(
        response.action === "inserted"
          ? "Performance approved insert successfully"
          : "Performance approved Update successfully",
      );
      navigate("/hod/performance?performanceList");
    } catch (error) {
      console.error("Submit review error:", error);

      alert(
        error.response?.data?.message || "Unable to save performance review",
      );
    } finally {
      setSaving(false);
    }
  };
  useEffect(() => {
    loadReview();
  }, [
    employeeId,
    deptId,
    systemRole,
    currentPage,
    recordsPerPage,
    filters.month,
    filters.frequency,
    filters.year,
    filters.quarter,
    filters.date,
  ]);

  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex =
    totalRecords === 0 ? 0 : (currentPage - 1) * recordsPerPage;

  const endIndex = Math.min(currentPage * recordsPerPage, totalRecords);
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };
  const getPageNumbers = () => {
    const pages = [];

    // No pages
    if (totalPages <= 0) {
      return pages;
    }

    // 1 - 5 pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Current page near beginning
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, "...", totalPages);

      return pages;
    }

    // Current page near end
    if (currentPage >= totalPages - 2) {
      pages.push(
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      );

      return pages;
    }

    // Current page in middle
    pages.push(
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    );

    return pages;
  };
  const handleMonthActualValueChange = (id, value, month) => {
    const monthIndex = {
      M1: 0,
      M2: 1,
      M3: 2,
      M4: 3,
      M5: 4,
      M6: 5,
      M7: 6,
      M8: 7,
      M9: 8,
      M10: 9,
      M11: 10,
      M12: 11,
    }[month];

    if (monthIndex === undefined) {
      return;
    }

    setKpis((prev) =>
      prev.map((item) => {
        if (Number(item.kpi_id) !== Number(id)) {
          return item;
        }

        // Always create exactly 12 positions
        const values = Array(12).fill("");

        // Read existing actual_value
        if (item.actual_value !== null && item.actual_value !== undefined) {
          const existingValues = String(item.actual_value).split(",");

          existingValues.forEach((val, index) => {
            if (index < 12) {
              values[index] = val;
            }
          });
        }

        // Change ONLY selected month
        values[monthIndex] = value;

        // Store all 12 values in one DB column
        const actualValue = values.join(",");

        // Separate timer for KPI + month
        const timerKey = `${id}_${month}`;

        if (saveTimers.current[timerKey]) {
          clearTimeout(saveTimers.current[timerKey]);
        }

        saveTimers.current[timerKey] = setTimeout(() => {
          saveMonthActualValue(id, actualValue, month);
        }, 700);

        return {
          ...item,

          // Main DB value
          actual_value: actualValue,

          // UI values
          actual_value_m1: values[0],
          actual_value_m2: values[1],
          actual_value_m3: values[2],
          actual_value_m4: values[3],
          actual_value_m5: values[4],
          actual_value_m6: values[5],
          actual_value_m7: values[6],
          actual_value_m8: values[7],
          actual_value_m9: values[8],
          actual_value_m10: values[9],
          actual_value_m11: values[10],
          actual_value_m12: values[11],
        };
      }),
    );
  };
  const saveMonthActualValue = async (id, value, monthIndex) => {
    try {
      const response = await axios.post(
        `${API}api/Performance/kpi/actual-value`,
        {
          kpi_id: id,
          actual_value: value,
          // Which quarter was changed
          month_index: monthIndex,
          employee_id: employeeId,
          frequency: filters.frequency,
          quarter: [""],
          month: filters.month,
          year: filters.year,
          review_date: filters.date,
          allocation_score: Number(data?.allocation?.allocation_score || 0),
          hours_score: Number(data?.allocation?.hours_score || 0),
          daily_score: Number(data?.daily_score || 0),
          kpi_score: Number(data?.kpi_score || 0),
          final_score: Number(data?.final_score || 0),
          manager_id: MANAGER_ID,
          reviewed_by: MANAGER_ID,
          status: reviewStatus,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
        },
      );

      console.log("Actual value saved:", response.data);
    } catch (error) {
      console.error("Error saving actual value:", error);
    }
  };
  const handleActualValueChange = (id, value, quarter) => {
    setKpis((prev) =>
      prev.map((item) => {
        if (item.kpi_id !== id) {
          return item;
        }

        // Existing DB value
        let values = item.actual_value
          ? String(item.actual_value).split(",")
          : [];

        // Always maintain 4 positions
        while (values.length < 4) {
          values.push("");
        }

        // Q1 = 0
        // Q2 = 1
        // Q3 = 2
        // Q4 = 3
        const quarterIndex = {
          Q1: 0,
          Q2: 1,
          Q3: 2,
          Q4: 3,
        }[quarter];

        if (quarterIndex === undefined) {
          return item;
        }

        // Update only selected quarter
        values[quarterIndex] = value;

        // DB value
        const actualValue = values.join(",");

        /*
        Example:

        Q1 = 100
        Q2 = 200
        Q3 = 300
        Q4 = 400

        actual_value:
        "100,200,300,400"
      */

        // Save separately for each KPI + quarter
        const timerKey = `${id}_${quarter}`;

        if (saveTimers.current[timerKey]) {
          clearTimeout(saveTimers.current[timerKey]);
        }

        saveTimers.current[timerKey] = setTimeout(() => {
          saveActualValue(id, actualValue, quarter);
        }, 700);

        // Update UI
        return {
          ...item,

          // Main DB field
          actual_value: actualValue,

          // Individual UI fields
          actual_value_q1: values[0],
          actual_value_q2: values[1],
          actual_value_q3: values[2],
          actual_value_q4: values[3],
        };
      }),
    );
  };
  const saveActualValue = async (id, value, quarterIndex) => {
    try {
      const response = await axios.post(
        `${API}api/Performance/kpi/actual-value`,
        {
          kpi_id: id,

          // Example:
          // Q1 = 100
          // Q2 = 200
          // Q3 = 300
          // Q4 = 400
          //
          // DB:
          // actual_value = "100,200,300,400"
          actual_value: value,

          // Which quarter was changed
          quarter_index: quarterIndex,

          employee_id: employeeId,
          frequency: filters.frequency,
          quarter: filters.quarter,
          month: filters.month,
          year: filters.year,
          review_date: filters.date,

          allocation_score: Number(data?.allocation?.allocation_score || 0),

          hours_score: Number(data?.allocation?.hours_score || 0),

          daily_score: Number(data?.daily_score || 0),

          kpi_score: Number(data?.kpi_score || 0),

          final_score: Number(data?.final_score || 0),

          manager_id: MANAGER_ID,
          reviewed_by: MANAGER_ID,
          status: reviewStatus,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
        },
      );

      console.log("Actual value saved:", response.data);
    } catch (error) {
      console.error("Error saving actual value:", error);
    }
  };
  const truncateWords = (text, limit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);

    if (words.length <= limit) {
      return text;
    }

    return words.slice(0, limit).join(" ") + "...";
  };
  return (
    <>
      <Modal show={modalReview} size="sl" id="reviewmodal">
        <div className="modal-body">
          <div className="decorative-shape shape-1"></div>
          <div className="decorative-shape shape-2"></div>
          <button
            type="button"
            className="float-end btn_close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="icon icon-cross fw-bold"></i>
          </button>
          <div
            className="dash_white_box_ttl text-center"
            id="exampleModalLabel"
          >
            Review Approval
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Manager Rating</label>

            <select
              className="form-select"
              value={rating}
              disabled={status !== "Pending" || saving}
              onChange={(e) => setRating(e.target.value)}
            >
              <option value="">Select Rating</option>

              <option value="1">1 - Poor</option>

              <option value="2">2 - Needs Improvement</option>

              <option value="3">3 - Good</option>

              <option value="4">4 - Very Good</option>

              <option value="5">5 - Excellent</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Review Status</label>

            <select
              className="form-select"
              value={reviewStatus}
              onChange={(e) => setReviewStatus(e.target.value)}
            >
              <option value="">Select Review Status</option>

              <option value="1">Pending</option>
              <option value="2">Approved</option>
              <option value="3">Reject</option>
            </select>
          </div>
          <div className="md-3">
            <label className="form-label fw-semibold">KPI Status</label>
            <select
              className="form-select"
              value={statusKpi}
              onChange={(e) => setKpiStatus(e.target.value)}
            >
              <option value="">Select KPI</option>
              {kpis.map((kra) => (
                <option key={kra.kpi_id} value={kra.kpi_id}>
                  {kra.kra_name}
                </option>
              ))}
            </select>
          </div>
          <div className="md-3">
            <label className="form-label fw-semibold">Manager Comment</label>

            <textarea
              rows="5"
              className="form-control"
              placeholder="Enter manager comments..."
              value={comment}
              disabled={status !== "Pending" || saving}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>

          {status.review?.rejection_reason && (
            <div className="alert alert-danger mt-3">
              <strong>Rejection Reason:</strong>{" "}
              {status.review.rejection_reason}
            </div>
          )}
          {/* ================= ACTION BUTTONS ================= */}
          <div className="modalfooter">
            {/* <span className="mb10 d-block text-right">{msg}</span> */}
            <div className="row">
              <div className="col-md-6 pr07">
                <button
                  type="button"
                  className="btn_5 w-100"
                  disabled={saving}
                  onClick={() => submitReview("Approved")}
                >
                  {saving ? "Saving..." : "Approve"}
                </button>
              </div>
              <div className="col-md-6 pl07">
                <button
                  type="button"
                  disabled={saving}
                  onClick={() => restReview("Reset")}
                  className="btn_6 w-100"
                  data-bs-dismiss="modal"
                >
                  {saving ? "Saving..." : "Reset"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <div className="page-header">
        <h1>
          Daily Performance Approval
          <button
            type="button"
            className="btn btn-sm btn-info mr08 float-end"
            onClick={openReviewModelHandler}
          >
            Review Approval
          </button>
          <button
            type="button"
            className="btn btn-sm btn-warning float-end mr08"
            onClick={() => navigate("/hod/performance?performanceList")}
          >
            ← Back
          </button>
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Performance{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Approval
          </li>
        </ul>
      </div>

      <div className="row_bg">
        {loading ? (
          <div className="dash_white_box2 mb20 p20">
            <div className="row mb30">
              <div className="performance-loading">
                Loading performance review...
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="page-sticky">
              <div className="dash_white_box2 mb20 p20">
                <div className="row mb10">
                  <div className="col-lg-3 col-md-6 pl07 pr07">
                    <label className="form-label">Frequency</label>
                    <select
                      className="form-select"
                      name="frequency"
                      value={filters.frequency}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          frequency: e.target.value,
                        })
                      }
                    >
                      <option value="Daily">Daily</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                  {filters.frequency === "Monthly" && (
                    <div className="col-lg-3 col-md-6 pl07 pr07">
                      <label className="form-label">Month</label>
                      <select
                        className="form-control"
                        value={filters.month}
                        name="month"
                        onChange={(e) =>
                          setFilters({
                            ...filters,

                            month: e.target.value,
                          })
                        }
                      >
                        <option value="">--Select Month--</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  )}
                  {filters.frequency === "Daily" && (
                    <div className="col-lg-3 col-md-6 pr07">
                      <label className="form-label">Date</label>

                      <DatePicker
                        selected={
                          filters.date
                            ? new Date(`${filters.date}T00:00:00`)
                            : null
                        }
                        onChange={handleDateChange}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="DD-MM-YYYY"
                        className="form-control"
                        name="date"
                        autoComplete="off"
                      />
                    </div>
                  )}
                  {filters.frequency === "Quarterly" && (
                    <div className="col-lg-3 col-md-6 pl07 pr07">
                      <label className="form-label">Quarter</label>
                      <Select
                        options={[
                          {
                            value: "Q1",
                            label: "Q1 (April-June)",
                          },
                          {
                            value: "Q2",
                            label: "Q2 (July-September)",
                          },
                          {
                            value: "Q3",
                            label: "Q3 (October-December)",
                          },
                          {
                            value: "Q4",
                            label: "Q4 (January-March)",
                          },
                        ]}
                        value={[
                          { value: "Q1", label: "Q1 (April-June)" },
                          { value: "Q2", label: "Q2 (July-September)" },
                          { value: "Q3", label: "Q3 (October-December)" },
                          { value: "Q4", label: "Q4 (January-March)" },
                        ].filter((option) =>
                          filters.quarter?.includes(option.value),
                        )}
                        onChange={(selected) => {
                          const quarters = (selected || []).map(
                            (item) => item.value,
                          );

                          setFilters((prev) => ({
                            ...prev,
                            quarter: quarters,
                          }));
                        }}
                        isMulti
                        isClearable
                        isSearchable
                        closeMenuOnSelect={false}
                        placeholder="Select Quarter"
                        classNamePrefix="quarter-select"
                      />
                    </div>
                  )}
                  <div className="col-lg-3 col-md-6 pl07 pr07">
                    <label className="form-label">Year</label>
                    <select
                      className="form-control"
                      value={filters.year}
                      name="year"
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          year: e.target.value,
                        })
                      }
                    >
                      <option value="">--Select Year--</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                    </select>
                  </div>
                </div>
                <div className="row float-end">
                  <div className="col-lg-12">
                    <label className="d-block mb10 pt07"></label>
                    <div className="d-flex gap-2">
                      <button
                        className="btn_2 btn-sm btn-info "
                        onClick={clearFilters}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dash_white_box2 mb20 p20">
              <div className="row mb30">
                {/* ================= EMPLOYEE DETAILS ================= */}
                <div className="col-md-4">
                  <div className="dash_white_box_ttl">Employee Details</div>

                  {/* Employee */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Employee:</strong>{" "}
                    <span>{data.employee.employee_name}</span>
                  </div>

                  {/* Employee Code */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Employee Code:</strong>
                    <span>{data.employee.employee_code}</span>
                  </div>

                  {/* Department */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Department:</strong>{" "}
                    <span> {data.employee.department_name}</span>
                  </div>

                  {/* Review Date */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Review Date:</strong> <span> {filters.date}</span>
                  </div>

                  {/* Manager */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Manager:</strong>{" "}
                    <span> {data.employee.manager_name}</span>
                  </div>

                  {/* Manager ID */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Manager ID:</strong>{" "}
                    <span> {data.employee.manager_id}</span>
                  </div>
                </div>
                {/* ================= Attendance DETAILS ================= */}
                {/* <div className="col-md-3">
                  <div className="dash_white_box_ttl">Attendance</div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Login Time:</strong>{" "}
                    <span> {attendance.login_time || "00:00"}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Logout Time:</strong>{" "}
                    <span> {attendance.logout_time || "00:00"}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Allocated Hours:</strong>{" "}
                    <span>
                      {" "}
                      {`${Number(attendance.allocated_hours || 0).toFixed(2)} hrs`}
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Completed Hours:</strong>{" "}
                    <span>
                      {" "}
                      {`${Number(attendance.completed_hours || 0).toFixed(2)} hrs`}
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Worked Minutes:</strong>{" "}
                    <span> {attendance.worked_minutes || 0}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Attendance Achievement:</strong>{" "}
                    <span>
                      {" "}
                      {`${Number(attendance.hours_score || 0).toFixed(2)}%`}
                    </span>
                  </div>
                </div> */}
                <div className="col-md-4">
                  <div className="dash_white_box_ttl">Performance Score</div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Attendance Score:</strong>{" "}
                    <span> {attendance.hours_score || "00:00"}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Daily Allocation Score:</strong>{" "}
                    <span> {allocation.allocation_score || 0}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>KPI Weighted Score:</strong>{" "}
                    <span> {data.kpi_score || 0}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Final Daily Performance:</strong>{" "}
                    <span> {data.final_score || 0}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="dash_white_box_ttl">Allocation Summary</div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Page Score:</strong>{" "}
                    <span>
                      {" "}
                      {Number(allocation.page_score || 0).toFixed(2)}%
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Allocation Hour Score:</strong>{" "}
                    <span>
                      {" "}
                      {Number(allocation.hours_score || 0).toFixed(2)}%
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Daily Allocation Score:</strong>{" "}
                    <span>
                      {" "}
                      {Number(allocation.allocation_score || 0).toFixed(2)}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="dash_white_box2 mb20 p20">
              <div className="dash_white_box_ttl">
                Daily Allocation {totalRecords}
              </div>
              <div className="row mb30">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table_style_1 table-bordered review-table">
                      <thead>
                        <tr>
                          <th>Task / Allocation</th>
                          <th>Employee Name</th>
                          <th>Stage</th>
                          <th>Allocated Pages</th>
                          <th>Completed Pages</th>
                          <th>Page Achievement</th>
                          <th>Allocated Hours</th>
                          <th>Completed Hours</th>
                          <th>Hour Achievement</th>
                        </tr>
                      </thead>

                      <tbody>
                        {allocations.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No allocation found for this date.
                            </td>
                          </tr>
                        ) : (
                          allocations.map((item) => (
                            <tr key={item.allocation_id}>
                              <td>
                                {item.task_name || item.stage_name || "-"}
                              </td>
                              <td>{item.employee_name || "-"}</td>
                              <td>{item.stage_name || "-"}</td>

                              <td>
                                {Number(item.allotted_pages || 0).toFixed(2)}
                              </td>

                              <td>
                                {Number(item.completed_pages || 0).toFixed(2)}
                              </td>

                              <td>
                                <strong>
                                  {Number(item.page_score || 0).toFixed(2)}%
                                </strong>
                              </td>

                              <td>
                                {Number(item.allotted_hours || 0).toFixed(2)}
                              </td>

                              <td>
                                {Number(item.completed_hours || 0).toFixed(2)}
                              </td>

                              <td>
                                <strong>
                                  {Number(item.hours_score || 0).toFixed(2)}%
                                </strong>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>

                      <tfoot>
                        <tr>
                          <th colSpan="3">Total</th>

                          <th>
                            {Number(
                              allocation.total_allotted_pages || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(
                              allocation.total_completed_pages || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(allocation.page_score || 0).toFixed(2)}%
                          </th>

                          <th>
                            {Number(
                              allocation.total_allotted_hours || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(
                              allocation.total_completed_hours || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(allocation.hours_score || 0).toFixed(2)}%
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  {/* =================================================
              PAGINATION
          ================================================= */}

                  {totalRecords > 0 && (
                    <div className="pagination-wrapper">
                      {/* Pagination Info */}
                      <div className="pagination-info">
                        Showing <strong>{startIndex + 1}</strong> to{" "}
                        <strong>{endIndex}</strong> of{" "}
                        <strong>{totalRecords}</strong> entries
                      </div>

                      {/* Pagination */}
                      <div className="pagination">
                        {/* Previous */}
                        <button
                          disabled={currentPage === 1 || loading}
                          onClick={() => goToPage(currentPage - 1)}
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>

                        {/* Page Numbers */}
                        {getPageNumbers().map((page, index) => {
                          if (page === "...") {
                            return (
                              <span
                                key={`dots-${index}`}
                                className="pagination-dots"
                              >
                                ...
                              </span>
                            );
                          }

                          return (
                            <button
                              key={page}
                              disabled={loading}
                              className={currentPage === page ? "active" : ""}
                              onClick={() => goToPage(page)}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {/* Next */}
                        <button
                          disabled={currentPage === totalPages || loading}
                          onClick={() => goToPage(currentPage + 1)}
                        >
                          <i className="bi bi-chevron-right"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="dash_white_box2 mb20 p20">
              <div className="dash_white_box_ttl">KPI / KRA Mapping</div>
              <div className="row mb30">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table
                      className="table_style_1 table-bordered review-table"
                      style={{
                        minWidth: "1200px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <thead>
                        {filters.frequency === "Daily" && (
                          <tr>
                            <th colSpan={9}>Daily</th>
                          </tr>
                        )}
                        {filters.frequency === "Yearly" && (
                          <tr>
                            <th colSpan={9}>Yearly</th>
                          </tr>
                        )}
                        {filters.frequency === "Quarterly" && (
                          <tr>
                            <th colSpan={4}></th>
                            {filters.quarter.includes("Q1") && (
                              <th colSpan={2}>Q1(April-June)</th>
                            )}
                            {filters.quarter.includes("Q2") && (
                              <th colSpan={2}> Q2(July-Sep)</th>
                            )}
                            {filters.quarter.includes("Q3") && (
                              <th colSpan={2}>Q3(Oct-Dec)</th>
                            )}
                            {filters.quarter.includes("Q4") && (
                              <th colSpan={2}>Q4(Jan-March)</th>
                            )}

                            <th colSpan={3}></th>
                          </tr>
                        )}
                        {filters.frequency === "Monthly" && (
                          <tr>
                            <th colSpan={4}></th>
                            <th colSpan={2}>January</th>
                            <th colSpan={2}> February</th>
                            <th colSpan={2}>March</th>
                            <th colSpan={2}>April</th>
                            <th colSpan={2}>May</th>
                            <th colSpan={2}>June</th>
                            <th colSpan={2}>July</th>
                            <th colSpan={2}>August</th>
                            <th colSpan={2}>September</th>
                            <th colSpan={2}>November</th>
                            <th colSpan={2}>December</th>
                            <th colSpan={3}></th>
                          </tr>
                        )}

                        <tr>
                          <th>KRA</th>
                          <th>KPI</th>
                          <th>Unit Value</th>
                          <th>Weightage</th>
                          {filters.frequency === "Daily" && (
                            <>
                              <th>Target</th>
                              <th>Actual</th>
                            </>
                          )}
                          {filters.frequency === "Yearly" && (
                            <>
                              <th>Target</th>
                              <th>Actual</th>
                            </>
                          )}
                          {filters.frequency === "Quarterly" && (
                            <>
                              {filters.quarter.includes("Q1") && (
                                <>
                                  <th>Target</th>
                                  <th>Actual</th>
                                </>
                              )}
                              {filters.quarter.includes("Q2") && (
                                <>
                                  <th>Target</th>
                                  <th>Actual</th>
                                </>
                              )}
                              {filters.quarter.includes("Q3") && (
                                <>
                                  <th>Target</th>
                                  <th>Actual</th>
                                </>
                              )}
                              {filters.quarter.includes("Q4") && (
                                <>
                                  <th>Target</th>
                                  <th>Actual</th>
                                </>
                              )}
                            </>
                          )}
                          {filters.frequency === "Monthly" && (
                            <>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                              <th>Target</th>
                              <th>Actual</th>
                            </>
                          )}
                          <th>
                            Total Target, FY-{filters.year}-
                            {Number(filters.year) + 1}
                          </th>
                          <th>
                            Total Actual, FY-{filters.year}-
                            {Number(filters.year) + 1}
                          </th>
                          <th>Total Score- Target and actual (in%)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {kpis.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No KPI/KRA mapping found.
                            </td>
                          </tr>
                        ) : (
                          kpis.map((item) => (
                            <tr key={item.kpi_id}>
                              <td>{item.kra_name || "-"}</td>

                              <td>
                                <span
                                  style={{ cursor: "pointer" }}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={
                                    item.kpi_name?.trim().split(/\s+/).length >
                                    5
                                      ? item.kpi_name
                                      : ""
                                  }
                                >
                                  {truncateWords(item.kpi_name, 5)}
                                </span>
                              </td>

                              <td>{item.target_unit || "-"}</td>

                              <td>{Number(item.weight || 0).toFixed(2)}%</td>

                              {filters.frequency === "Quarterly" && (
                                <>
                                  {filters.quarter.includes("Q1") && (
                                    <>
                                      <td>
                                        {Number(item.target_value || 0).toFixed(
                                          2,
                                        )}
                                      </td>

                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="actual_value_q1"
                                          value={item.actual_value_q1 ?? ""}
                                          onChange={(e) =>
                                            handleActualValueChange(
                                              item.kpi_id,
                                              e.target.value,
                                              "Q1",
                                            )
                                          }
                                        />
                                      </td>
                                    </>
                                  )}

                                  {filters.quarter.includes("Q2") && (
                                    <>
                                      <td>
                                        {Number(item.target_value || 0).toFixed(
                                          2,
                                        )}
                                      </td>

                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="actual_value_q2"
                                          value={item.actual_value_q2 ?? ""}
                                          onChange={(e) =>
                                            handleActualValueChange(
                                              item.kpi_id,
                                              e.target.value,
                                              "Q2",
                                            )
                                          }
                                        />
                                      </td>
                                    </>
                                  )}

                                  {filters.quarter.includes("Q3") && (
                                    <>
                                      <td>
                                        {Number(item.target_value || 0).toFixed(
                                          2,
                                        )}
                                      </td>

                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="actual_value_q3"
                                          value={item.actual_value_q3 ?? ""}
                                          onChange={(e) =>
                                            handleActualValueChange(
                                              item.kpi_id,
                                              e.target.value,
                                              "Q3",
                                            )
                                          }
                                        />
                                      </td>
                                    </>
                                  )}

                                  {filters.quarter.includes("Q4") && (
                                    <>
                                      <td>
                                        {Number(item.target_value || 0).toFixed(
                                          2,
                                        )}
                                      </td>

                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="actual_value_q4"
                                          value={item.actual_value_q4 ?? ""}
                                          onChange={(e) =>
                                            handleActualValueChange(
                                              item.kpi_id,
                                              e.target.value,
                                              "Q4",
                                            )
                                          }
                                        />
                                      </td>
                                    </>
                                  )}
                                </>
                              )}
                              {filters.frequency === "Monthly" && (
                                <>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m1"
                                      value={item.actual_value_m1 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M1",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m2"
                                      value={item.actual_value_m2 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M2",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m3"
                                      value={item.actual_value_m3 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M3",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m4"
                                      value={item.actual_value_m4 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M4",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m5"
                                      value={item.actual_value_m5 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M5",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m6"
                                      value={item.actual_value_m6 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M6",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.actual_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m7"
                                      value={item.actual_value_m7 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M7",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.actual_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m8"
                                      value={item.actual_value_m8 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M8",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m9"
                                      value={item.actual_value_m9 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M9",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m10"
                                      value={item.actual_value_m10 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M10",
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="actual_value_m11"
                                      value={item.actual_value_m11 ?? ""}
                                      onChange={(e) =>
                                        handleMonthActualValueChange(
                                          item.kpi_id,
                                          e.target.value,
                                          "M11",
                                        )
                                      }
                                    />
                                  </td>
                                </>
                              )}
                              {filters.frequency === "Daily" && (
                                <>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    {Number(item.actual_value || 0).toFixed(2)}
                                  </td>
                                </>
                              )}
                              {filters.frequency === "Yearly" && (
                                <>
                                  <td>
                                    {Number(item.target_value || 0).toFixed(2)}
                                  </td>
                                  <td>
                                    {Number(item.actual_value || 0).toFixed(2)}
                                  </td>
                                </>
                              )}

                              <td>
                                <strong>
                                  {Number(item.totalTarget || 0).toFixed(2)}%
                                </strong>
                              </td>

                              <td>
                                <strong>
                                  {Number(item.totalActual || 0).toFixed(2)}%
                                </strong>
                              </td>
                              <td>
                                <strong>
                                  {Number(item.totalScore || 0).toFixed(2)}%
                                </strong>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default HodPerformanceReview;
